
import { GspAttributeState } from './types';

export const state = (): GspAttributeState => initialState();

export const initialState = (): GspAttributeState => ({
  gspAttributes: {
    //TODO remove when was made backend
    items: [],
    isLoading: undefined,
    total: 2, //TODO remove when was made backend
    searchParams: {
      dataOption: {
        page: 1,
        itemsPerPage: 25,
        sortBy: [],
        sortDesc: [false],
        groupBy: [],
        groupDesc: [],
        multiSort: true,
        mustSort: false,
      },
      filter: '',
      orClauseFieldsIds: ['name'],
      andClauseFieldsIds: [],
    },
  },
});
